




































import { defineComponent, ref, watch } from '@vue/composition-api';
import moment from 'moment';
import { dateValidRule } from '@/shared/date-format-rule';
import { ymdLeadZerosWDash } from '@/constants/dateTime';

export default defineComponent({
  emits: ['date-updated'],
  props: {
    isoDate: {
      required: true,
      type: String,
    },
    rules: {
      default: () => [],
      type: Array,
    },
    errorMessage: {
      default: '',
      type: String,
    },
    dateFormat: { default: '', type: String },
  },
  setup(props, ctx) {
    const dateOpen = ref(false);
    // Ensure dateFormat is valid, fallback to MM/DD/YYYY
    const validDateFormat = props.dateFormat || 'MM/DD/YYYY';
    const readableDate = ref(
      props.isoDate ? moment.utc(props.isoDate).format(validDateFormat) : '',
    );

    const emit = val => {
      ctx.emit('date-updated', val);
    };

    watch(
      () => props.isoDate,
      newVal => {
        readableDate.value = newVal
          ? moment.utc(newVal).format(validDateFormat)
          : '';
      },
    );

    return {
      dateOpen,
      readableDate,
      onTextChange: v => {
        // The EditPatientDialog is expecting YYYY-MM-DD for manually
        // entered date values.
        if (!v || dateValidRule(v, validDateFormat, 130, 0) !== true) return;
        emit(moment(v, validDateFormat).format(ymdLeadZerosWDash));
      },
      onDateChange: v => {
        // Value returned by v-date-picker will match YYYY-MM-DD
        emit(v);
        dateOpen.value = false;
      },
    };
  },
});
